require('~/scss/style.scss')

/* eslint-disable no-unused-vars */
import 'jquery-modal'
import 'lazysizes'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'magnific-popup'

import '~/js/barcode-generator'
import '~/js/gtm'
import '~/js/helpers/scroll'
import '~/js/points/login'

import '~/js/blocks/teikibin-point-item'
import '~/js/blocks/teikibin-product-popup'

import '~/js/sections/articles'
import '~/js/sections/categoryAccordion'
import '~/js/sections/collectionItems'
import '~/js/sections/fader'
import '~/js/sections/frais-2026'
import '~/js/sections/linkSlider'
import '~/js/sections/main-article-contest'
import '~/js/sections/main-blog-contest'
import '~/js/sections/productReview'
import '~/js/sections/recentItems'
import '~/js/sections/teikibin-concept'
import '~/js/sections/teikibin-header'
import '~/js/sections/teikibin-mainview'
import '~/js/sections/teikibin-product'
import '~/js/sections/teikibin-qa'
import '~/js/sections/teikibin-records'
import '~/js/sections/teikibin-review'
import '~/js/sections/teikibin-select'
import '~/js/sections/teikibin-theme'

import '~/js/snippets/collection-ranking'
import '~/js/snippets/colorSelector'
import '~/js/snippets/header-v3/index'
import '~/js/snippets/image-slider'
import '~/js/snippets/link-list'
import '~/js/snippets/member-card'
import '~/js/snippets/not-found'
import '~/js/snippets/product-list'
import '~/js/snippets/products-search'
import '~/js/snippets/recent-items'
import '~/js/snippets/smart-up-banner'

import '~/js/templates/404/index'
import '~/js/templates/article/colorAnalysis'
import '~/js/templates/article/contest'
import '~/js/templates/article/index'
import '~/js/templates/article/simulation'
import '~/js/templates/blog/articles'
import '~/js/templates/blog/contest'
import '~/js/templates/blog/coordinate'
import '~/js/templates/blog/feature'
import '~/js/templates/blog/index'
import '~/js/templates/blog/paginator'
import '~/js/templates/cart/index'
import '~/js/templates/collection/index'
import '~/js/templates/customers/account/activate-account'
import '~/js/templates/customers/account/emailaddress'
import '~/js/templates/customers/account/favorites'
import '~/js/templates/customers/account/index'
import '~/js/templates/customers/account/info'
import '~/js/templates/customers/account/login'
import '~/js/templates/customers/account/mydiscounts'
import '~/js/templates/customers/account/point-history'
import '~/js/templates/customers/account/product-list'
import '~/js/templates/customers/account/quotes'
import '~/js/templates/customers/account/questionnaire'
import '~/js/templates/customers/account/register'
import '~/js/templates/customers/account/reset-password'
import '~/js/templates/customers/account/resign'
import '~/js/templates/customers/order/index'
import '~/js/templates/index/categories'
import '~/js/templates/index/category'
import '~/js/templates/index/feature'
import '~/js/templates/index/hashtags'
import '~/js/templates/index/news'
import '~/js/templates/index/slider'
import '~/js/templates/page/addToCart'
import '~/js/templates/page/categoryList'
import '~/js/templates/page/contentsAll'
import '~/js/templates/page/colorAnalysis'
import '~/js/templates/page/customProducts'
import '~/js/templates/page/email-change-confirm'
import '~/js/templates/page/hashtag'
import '~/js/templates/page/productList'
import '~/js/templates/page/recent'
import '~/js/templates/page/reviewMaster'
import '~/js/templates/page/reviewPost'
import '~/js/templates/page/setAcceptsMarketing'
import '~/js/templates/page/stores'
import '~/js/templates/page/hulk-form'
import '~/js/templates/product/index'
import '~/js/templates/product/review'
import '~/js/templates/search/index'

import addAddressToMetafield from './add-address-metafield'
import addAppUidToMetafield from './add-app-uid-metafield'
import { initAddressForms } from './address'
import './autocomplete'
import './cancel-order-scripts'
import {
  initDeliveryDateCalendar,
  initDeliveryDateRange,
  initMainDeliveryBanner,
} from './delivery-date-calendar'
import './fields'
import './forms/inputValidations'
import { checkForAppUid } from './login'
import './modal'
import { bindModalClose } from './modal-order-curtain-confirm'
import orderDetails from './pages/order-details'
import './qty-update'
import './set-header-margin'
import setUtmParameters from './utm-parameters'
import './zendesk-cookie'

orderDetails()

const $doc = $(document)

$doc.ready(() => {
  bindModalClose()

  //UTM parameters
  setUtmParameters()

  if (window.location.href.includes('account')) {
    // bindPointsStatus(); - migrated to omo.js
    addAddressToMetafield()
    addAppUidToMetafield()
    checkForAppUid()
  }

  if (window.location.href.includes('/pages/delivery_calendar')) {
    initDeliveryDateRange()
    initMainDeliveryBanner()
    initDeliveryDateCalendar()
  }

  if (window.location.href.includes('/account?view=addresses')) {
    initAddressForms()
  }

  if (window.location.href.includes('/orders/')) {
    $('#receipt-popup .btn-close').click((e) => {
      e.preventDefault()
      $.magnificPopup.close()
    })
  }
})

//Details Popup
$('.popup-link').magnificPopup({
  type: 'inline',
  closeBtnInside: false,
  midClick: true,
})
